import { render, staticRenderFns } from "./calendar.vue?vue&type=template&id=64f23723"
var script = {}


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src4020427597/src/jobbliss-app-vue/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('64f23723')) {
      api.createRecord('64f23723', component.options)
    } else {
      api.reload('64f23723', component.options)
    }
    module.hot.accept("./calendar.vue?vue&type=template&id=64f23723", function () {
      api.rerender('64f23723', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/icons/calendar.vue"
export default component.exports